import { useAuth } from '@interhyp/util-authentication';
import { PermissionsProvider } from '@interhyp/util-permissions';
import { getConnection } from '@interhyp/util-request';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { useConfiguration, useScrollToTop, useSessionHeartbeat } from '../../hooks';
import { useFrontendNotifications } from '../../hooks/useFrontendNotifications';
import { initSession } from '../../redux/StateSession/actions';
import { Viewport } from '../components/Viewport';

window.__conn = getConnection();
window.__conn.addHeader('Content-Type', 'application/json');

function AuthenticatedApp() {
  useFrontendNotifications();
  useFavicon();
  useSessionHeartbeat(); // trigger login
  useConfiguration(); // trigger config load
  useScrollToTop();
  const { token } = useAuth();
  return (
    <PermissionsProvider bitmask={token?.permissions || ''}>
      <Viewport />
    </PermissionsProvider>
  );
}

function useFavicon() {
  useEffect(() => {
    if (
      window.location.href.includes('sales.interhyp.de') ||
      window.location.href.includes('interhyp.sales.')
    ) {
      const favicon = document.querySelector('#favicon');
      favicon.href = '/assets/interhyp/favicon.ico';
    }
  }, []);
}

function App({ onAuth }) {
  const { client, done } = useAuth();

  useEffect(() => {
    if (done === true) {
      onAuth(client === 'broker');
    }
  }, [client, done, onAuth]);

  if (done === false) {
    return null;
  }
  return <AuthenticatedApp />;
}

const stateToProps = _state => ({});

const dispatchToProps = dispatch => ({
  onAuth: isBroker => {
    dispatch(initSession(isBroker));
  },
});

const ConnectedApp = connect(stateToProps, dispatchToProps)(App);

export { ConnectedApp as App };
